import { SET_USER_REGION } from '../../mutation-types';
import { writeCookie } from '../../../../util/dom/cookie';
import { REGION_COOKIE_KEY } from './constants';

export function setUserRegion({ commit }, { region }) {
    // save this value persistently in the session cookies
    writeCookie({
        key: REGION_COOKIE_KEY,
        value: region,
        path: '/',
    });

    commit(SET_USER_REGION, { region });
}
